import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideAlertModal } from 'state/actions/actions';
import Modal from 'tailwind-components/Modal/Modal';
import Button from 'tailwind-components/Button/Button';
import { Stack } from '@mui/material';
import { sanitizeDirtyHTML } from 'helpers/strings';

function AlertModal() {
  const alert = useSelector(state => state.site.alertModal);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(hideAlertModal());
  };

  return (
    <Modal
      alert
      active={alert.active}
      title={alert.title}
      size={alert.size}
      hideFooter={alert.hideFooter}
      footer={
        <Button
          fill
          variant='primaryLight'
          text={alert.buttonText}
          onClick={handleCloseModal}
        />
      }
      closeModal={handleCloseModal}
    >
      <Stack sx={{ whiteSpace: 'break-spaces' }}>
        <div
          dangerouslySetInnerHTML={sanitizeDirtyHTML(alert.message || '')}
        ></div>
      </Stack>
    </Modal>
  );
}

export default AlertModal;
